<div class="pdf-page app-il-00-17-11-98" id="il171198">
  <p style="text-align: right" class="font-small p-5"><b>IL 00 17 11 98</b></p>
  <p class="font-large" style="text-align: center">
    <b>COMMON POLICY CONDITIONS</b>
  </p>
  <p class="font-small">
    All Coverage Parts included in this policy are subject to the following
    conditions.
  </p>
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ol type="A">
            <li style="padding-bottom: 10px;">
              <b>Cancellation</b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  The first Named Insured shown in the Declarations may cancel
                  this policy by mailing or delivering to us advance written
                  notice of cancellation
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  We may cancel this policy by mailing or delivering to the
                  first Named Insured written notice of cancellation at least:
                 
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      10 days before the effective date of cancellation if we
                      cancel for nonpayment of premium; or
                      </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      30 days before the effective date of cancellation if we
                      cancel for any other reaso
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  We will mail or deliver our notice to the first Named
                  Insured's last mailing address known to us.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  Notice of cancellation will state the effective date of
                  cancellation. The policy period will end on that date.
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  If this policy is cancelled, we will send the first Named
                  Insured any premium refund due. If we cancel, the refund will
                  be pro rata. If the first Named Insured cancels, the refund
                  may be less than pro rata. The cancellation will be effective
                  even if we have not made or offered a refund.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  If notice is mailed, proof of mailing will be sufficient proof
                  of notice.
                </span>
                </li>
              </ol>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
              <b>Changes</b><br />
              This policy contains all the agreements between you and us
              concerning the insurance afforded. The first Named Insured shown
              in the Declarations is authorized to make changes in the terms of
              this policy with our consent. This policy's terms can be amended
              or waived only by endorsement issued by us and made a part of this
              policy.
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">

              <b>Examination Of Your Books And Records</b>
            </li>           
            We may examine and audit your books and records as they relate to
            this policy at any time during the policy period and up to three
            years afterward.
            <li style="padding-bottom: 10px;">
              <b>Inspections And Surveys</b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  We have the right to:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      Make inspections and surveys at any time;
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  <ol type="a" start="2">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      Give you reports on the conditions we find; and
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      Recommend changes.
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ul>
            </span>
            </li>
          </ul>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  We are not obligated to make any inspections, surveys, reports
                  or recommendations and any such actions we do undertake relate
                  only to insurability and the premiums to be charged. We do not
                  make safety inspections. We do not undertake to perform the
                  duty of any person or organization to provide for the health
                  or safety of workers or the public. And we do not warrant that
                  conditions:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      Are safe or healthful; or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                      Comply with laws, regulations, codes or standards.
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  Paragraphs <b>1.</b> and <b>2.</b> of this condition apply not
                  only to us, but also to any rating, advisory, rate service or
                  similar organization which makes insurance inspections,
                  surveys, reports or recommendations.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  Paragraph <b>2.</b> of this condition does not apply to any
                  inspections, surveys, reports or recommendations we may make
                  relative to certification, under state or municipal statutes,
                  ordinances or regulations, of boilers, pressure vessels or
                  elevators.
                </span>
                </li>
              </ol>
            </li>
          </ul>
          <ol type="A" start="5">
            <li style="padding-bottom: 10px; font-weight: bold;">
              <span style="font-weight: normal;">
              <b>Premiums </b><br />
              The first Named Insured shown in the Declarations:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  Is responsible for the payment of all premiums; and
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  Will be the payee for any return premiums we pay.
                  </span>
                </li>
              </ol>
            </span>
            </li>
            <li style="padding-bottom: 10px;">
              <b>Transfer Of Your Rights And Duties Under This Policy</b><br />
              Your rights and duties under this policy may not be transferred
              without our written consent except in the case of death of an
              individual named insured. <br />
              If you die, your rights and duties will be transferred to your
              legal representative but only while acting within the scope of
              duties as your legal representative. Until your legal
              representative is appointed, anyone having proper temporary
              custody of your property will have your rights and duties but only
              with respect to that property.
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
